export class CampaignStatusUpdateError extends Error {
  constructor(message) {
    super(message);
  }
}

